import {HardReset, Transport} from 'esptool-js';

/** Release Web Serial's writer after a failed write so disconnect can close. */
export class Esp32LoaderTransport extends Transport {
  override async setSignals(dtr?: boolean, rts?: boolean, breakSignal?: boolean): Promise<void> {
    // Upstream only remembers truthy DTR, leaving GPIO0's cached state active
    // after release. setRTS's Windows workaround then applies that stale state.
    if (dtr !== undefined) this._DTR_state = dtr;
    await super.setSignals(dtr, rts, breakSignal);
  }

  override async write(data: Uint8Array): Promise<void> {
    const writable = this.device.writable;
    if (!writable) throw new Error('Cổng USB không còn nhận dữ liệu. Kết nối lại rồi thử lại.');
    const writer = writable.getWriter();
    try {
      // Do not trace raw packets: reads and writes may contain station secrets.
      await writer.write(this.slipWriter(data));
    } finally {
      writer.releaseLock();
    }
  }
}

/** Pulse EN with GPIO0 released so verified firmware boots out of the stub. */
export class Esp32FirmwareReset extends HardReset {
  constructor(transport: Pick<Transport, 'setSignals'>) {
    // Extending HardReset satisfies esptool-js's factory type (which includes
    // private fields). This override requires only the public signal method.
    super(transport as Transport);
  }

  override async reset(): Promise<void> {
    try {
      await this.transport.setSignals(false, false);
      await this.transport.setSignals(false, true);
      await new Promise<void>(resolve => setTimeout(resolve, 100));
    } finally {
      // Both signals are released even if asserting EN failed. GPIO0 is never
      // pulled low, so the release starts the application instead of ROM mode.
      await this.transport.setSignals(false, false);
    }
  }
}
